import { z } from 'zod';
import { EXPORT_DATA_TYPE, EXPORT_FORM_FIELD, EXPORT_OUTPUT_FORMAT } from '../types';

export const defaultValues = {
  [EXPORT_FORM_FIELD.OUTPUT_FORMAT]: EXPORT_OUTPUT_FORMAT.CSV,
  [EXPORT_FORM_FIELD.DATA_TYPE_NAME]: EXPORT_DATA_TYPE.EMAIL_SEND,
  [EXPORT_FORM_FIELD.OMIT_FIELDS]: '',
  [EXPORT_FORM_FIELD.ONLY_FIELDS]: '',
  [EXPORT_FORM_FIELD.DELIMITER]: ',',
};

export const exportFormSchema = z.object({
  [EXPORT_FORM_FIELD.ORG_ID]: z.number(),
  [EXPORT_FORM_FIELD.PROJECT_ID]: z.number(),
  [EXPORT_FORM_FIELD.OUTPUT_FORMAT]: z.nativeEnum(EXPORT_OUTPUT_FORMAT),
  [EXPORT_FORM_FIELD.DATA_TYPE_NAME]: z.nativeEnum(EXPORT_DATA_TYPE),
  [EXPORT_FORM_FIELD.START_TIME]: z.string().optional(),
  [EXPORT_FORM_FIELD.END_TIME]: z.string().optional(),
  [EXPORT_FORM_FIELD.OMIT_FIELDS]: z.string().optional(),
  [EXPORT_FORM_FIELD.ONLY_FIELDS]: z.string().optional(),
  [EXPORT_FORM_FIELD.CAMPAIGN_ID]: z.number().optional(),
  [EXPORT_FORM_FIELD.DELIMITER]: z.string().optional(),
});
